module.exports = [
	{
		"datacode": "biodiversity_hotspots",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Biodiversity Hotspots",
		"shortdescription": "Regions with high levels of endemism and human threat.",
		"description": "Conservation International defined 35 biodiversity hotpsots around the world where biodiversity conservation is most urgent because of high levels of endemism and human threat.",
		"source": "Conservation International, 2011. \"Biodiversity hotspots.\" Accessed through Global Forest Watch on July 18, 2017: ",
		"sourceurl": "http://www.globalforestwatch.org",
		"fullcitation": null,
		"fill_color": "255, 255, 190",
		"fill_opacity": "1",
		"stroke_color": "255, 255, 0",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "6",
		"tile_opacity": null
	},
	{
		"datacode": "birds_richness_all_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Bird Species Richness",
		"shortdescription": "Bird Species Richness (2018).",
		"description": "Species richness refers to the diversity of bird species in a measured area. Primary bird species range-map data used to create the diversity maps on BiodiversityMapping.org are from BirdLife International and NatureServe. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps for all the world's birds in BirdLife International and NatureServe (2018)",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,677.8",
		"legend_units_label_single": "Number of Bird Species",
		"legend_units_label": null,
		"listed_order": "9",
		"tile_opacity": null
	},
	{
		"datacode": "birds_threatened_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Threatened Birds",
		"shortdescription": "Threatened Birds (2018).",
		"description": "Threatened in this case refers to birds that are vulnerable, endangered, or critically endangered (IUCN). Threatened bird species range-map data used to create the diversity maps on BiodiversityMapping.org are from BirdLife International and NatureServe. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps for all the world's birds in BirdLife International and NatureServe (2018)",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,31.2",
		"legend_units_label_single": "Number of Bird Species",
		"legend_units_label": null,
		"listed_order": "10",
		"tile_opacity": null
	},
	{
		"datacode": "boreal",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Global Boreal Forest Extent",
		"shortdescription": "Boreal/Taiga Forest extent.",
		"description": "This data layer represents the northern extent of the Boreal forest, worldwide. The Boreal extent includes the closed-canopy forest and the taiga (which consists of lichen woodland and forest tundra). The closed-canopy forest is the southernmost portion, contains the greatest richness of species and  has the longest growing season within the boreal zone. North of the closed-canopy forest is the taiga, a zone that ranges from sparse forest in which tree crowns do not form a closed canopy to patches of trees consisting of only a few species that populate certain portions of the landscape. The data layer was derived from The Nature Conservancy’s Global Ecoregions, Major Habitat Types, Biogeographical Realms and The Nature Conservancy Terrestrial Assessment Units as of December 14, 2009. To better identify the North American Boreal, the Natural Resource Canada dataset (called North American Boreal Forest Extent) presented in the next map should be used, as it is the one most currently accepted for that region of the world.",
		"source": "Boreal/Taiga Forest Extent from The Nature Conservancy Terrestrial Ecoregions. Accessed Aug 08, 2017.",
		"sourceurl": "http://maps.tnc.org/gis_data.html",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": "0.4",
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "5",
		"tile_opacity": "0.4"
	},
	{
		"datacode": "boreal_caribou_range_June62012",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Caribou Distribution",
		"shortdescription": "Boreal Woodland Caribou Range (2012).",
		"description": "This dataset was compiled by the Environment Canada's Science and Technology Division. It illustrates the occurrence of woodland caribou (rangifer tarandus caribou, forest-dwelling ecotype) across Canada as depicted in the National Recovery Strategy, based on information provided by provincial and territorial jurisdictions to Environment Canada and interpreted from 2008-2010 Landsat satellite imagery, updated to 2012 range boundaries.",
		"source": "Boreal Woodland Caribou (forest-dwelling ecotype) Occurrence in Canada, Environment Canada's Science and Technology Division. January 01, 2013. Accessed January 13, 2020",
		"sourceurl": "https://open.canada.ca/data/en/dataset/890a5d8d-3dbb-4608-b6ce-3b6d4c3b7dce",
		"fullcitation": "Environment Canada's Science and Technology Division, Anthropogenic disturbance footprint within boreal caribou ranges across Canada - As interpreted from 2008-2010 Landsat satellite imagery Updated to 2012 range boundaries, January 01, 2013. Accessed January 13, 2020",
		"fill_color": "255, 170, 0",
		"fill_opacity": "0.4",
		"stroke_color": "230, 152, 0",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "5",
		"tile_opacity": null
	},
	{
		"datacode": "boreal_na",
		"datatype": "tileLayer",
		"theme": null,
		"layerlabel": "North America Boreal Forest Extent",
		"shortdescription": "North American Boreal Forest Extent.",
		"description": "The circumpolar boreal zone is one of the world’s major biogeoclimatic zones, covering much of North America and Eurasia with forests, woodlands, wetlands, and lakes. It regulates climate, acts as a reservoir for biological and genetic diversity, plays a key role in biogeochemical cycles, and provides renewable resources, habitat, and recreational opportunities. Poor agreement exists amongst scientists regarding this zone’s delimitation and the areal extent of boreal forests, even though the zone has been well-studied. This paper reviews the literature on the phytogeography of the zone and makes use of a geographic information system (GIS) and published maps to delineate a current map of the North American boreal zone and the hemiboreal subzone, which is a transitional area lying immediately to the south of the boreal zone that is usually included in the boreal zone by Europeans but excluded by North Americans. On the basis of the map described here, the boreal zone covers about 627 million ha, or 29% of the North American continent north of Mexico. If the hemiboreal subzone, at 116 million ha, is included, then 34% of the same area is covered. Forests and other wooded land (362 million ha) cover 58% of the North American boreal zone on the basis of current forest inventory data. With forests and other wooded land of the hemiboreal subzone (68 million ha) factored in, this percentage remains basically unchanged. Values reported in this paper are compared with other published statistics. Important sources of error contributing to differences in areal statistics are discussed.",
		"source": "Citation : Brandt, J. P. Natural Resources Canada, The Extent of the North America Boreal Zone Environmental Reviews, 2009, 17(NA): 101-161.",
		"sourceurl": "https://doi.org/10.1139/A09-004",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": "0.4",
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "6",
		"tile_opacity": "0.4"
	},
	{
		"datacode": "broadback_hotspot",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Broadback Watershed Boundary",
		"shortdescription": "Watershed extent of the Broadback River.",
		"description": "As of 2015, two thirds of the Broadback Forest, an intact forest landscape in Canada's Boreal Forest in the province of Quebec, is officially protected. Protection such as this is of critical importance for human communities, the bird and animal species that rely on the forest, and the ecological services they provide. Conservation for the remaining third of the area is proposed for protection, and is crucial to maintaining biodiversity, viable caribou habitat, and the local First Nations way of life.",
		"source": "Broadback River Watershed in Time-series Analyses of Change in Broadback River Watershed and Adjacent Area. 2016. Global Forest Watch Canada. Accessed through CARTO, Sept 27, 2017: ",
		"sourceurl": "https://gfwcbroadback.carto.com/tables/broadback_watershed/public ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "carbon_density",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Forest Carbon Density",
		"shortdescription": "Aboveground forest carbon biomass density (2016).",
		"description": "Forest biomass density plays a large role in estimating the carbon storage potential of forests. Biomass is biological material derived from living or recently living organisms. Carbon density values can be estimated as 50 percent of biomass density values, though data presented here should not be used for official assessments. This is the first global biomass map based on field observations and remote sensing data to assess the aboveground biomass of woody vegetation at 0.01 degree resolution. The map covers only forest areas, where forests are defined as areas with dominance of tree cover in the GLC2000 map (Bartholomé and Belward, 2005).",
		"source": "Avitabile, V., Herold, M., Heuvelink, G., Lewis, S.L., Phillips, O.L., Asner, G.P. et al. (2016). Accessed, July 24 2017: ",
		"sourceurl": "http://www.wur.nl/en/Expertise-Services/Chair-groups/Environmental-Sciences/Laboratory-of-Geo-information-Science-and-Remote-Sensing/Research/Integrated-land-monitoring/Forest_Biomass.htm",
		"fullcitation": "Avitabile V., Herold, M., Heuvelink, G., Lewis, S.L., Phillips, O.L., Asner, G.P. et al. (2016). An integrated pan-tropical biomass map using multiple reference datasets. Global Change Biology, 22: 1406-1420. doi:10.1111/gcb.13139.",
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "675, 37850",
		"legend_units_label_single": "0.01 tons biomass C/hectare",
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "carbon_density_boreal",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Forest Carbon Density Boreal",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": "675, 37850",
		"legend_units_label_single": "0.01 tons biomass C/hectare",
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "ee_broadback_marker",
		"datatype": "marker",
		"theme": "earth engine map marker",
		"layerlabel": "ee_broadback_marker",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "50.35158,-73.56894",
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "elephant_merge_03022020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Elephant Distribution",
		"shortdescription": "Sumatran Elephant habitat range (2008).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran elephant (elephas maximus sumatrensis) has been placed on the list of critically endangered species after losing half of its population in a single generation, prompting calls from conservation groups for emergency measures to halt the destruction of its habitat. Canopy digitized the 2008 Sumatran elephant population range from the World Wildlife Fund, Decline of the Sumatran elephant map featured in The Guardian on January 24, 2012. This file was merged with the Sumatran extent of the Elephas maximus range provided by IUCN.",
		"source": "The Decline of the Sumatran Elephant,\" map based on World Wildlife Fund data, in Watts, Jonathan. 2012. Sumatran elephant upgraded to critically endangered status. The Guardian. Digitized August, 2017. Merged with Sumatran extent of Elephas maximus (Asian Elephant) data provided by IUCN. Last assessed June 30, 2008; accessed January 6, 2020.",
		"sourceurl": "https://www.theguardian.com/environment/2012/jan/24/sumatran-elephant-upgraded-critically-endangered; https://www.iucnredlist.org/species/7140/12828813",
		"fullcitation": "IUCN: Choudhury, A., Lahiri Choudhury, D.K., Desai, A., Duckworth, J.W., Easa, P.S., Johnsingh, A.J.T., Fernando, P., Hedges, S., Gunawardena, M., Kurt, F., Karanth, U., Lister, A., Menon, V., Riddle, H., Rübel, A. & Wikramanayake, E. (IUCN SSC Asian Elephant Specialist Group) 2008. Elephas maximus . The IUCN Red List of Threatened Species 2008: e.T7140A12828813. https://dx.doi.org/10.2305/IUCN.UK.2008.RLTS.T7140A12828813.en. Downloaded on 06 January 2020.",
		"fill_color": "255, 255, 0",
		"fill_opacity": "0.6",
		"stroke_color": "104, 104, 104",
		"stroke_weight": "0.1",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "global_aef",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Ancient and Endangered Forests",
		"shortdescription": "Forest landscapes containing high ecological value and high levels of threat.",
		"description": "This dataset identifies the characteristics and locations of Ancient and Endangered Forests (AEF) around the world. The AEF layer is a composite of 25 core geospatial datasets representing key ecological characteristics of high value forests available at global scales. Our definition of AEF and the selection of the core datasets is based on the latest frameworks for defining Ancient and Endangered Forests from leading biodiversity and conservation scientists and environmental non-governmental organizations. \n\nIn this application, AEF is defined as: intact forest landscape mosaics, naturally rare forest types, forest types that have been made rare due to human activity, forests with high species richness, forests containing high concentrations of rare and endangered species, forests of high endemism, core habitat for focal species, or forests exhibiting rare ecological and evolutionary phenomena. \n\nThe Ancient and Endangered Forest landscapes presented in ForestMapper do not comprise all of the ecological components and values identified in our definition, but rather present the landscapes that contain at least one of the core components or values associated with the AEF definition. This ensures that all potential ecologically important forests are represented and that no critical areas – from an ecological standpoint – are overlooked. ",
		"source": null,
		"sourceurl": "http://canopyplanet.org/tools/forestmapper/methods-references/#sources",
		"fullcitation": null,
		"fill_color": "0, 109, 44",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "great_bear_rainforest",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Great Bear Rainforest Boundary",
		"shortdescription": "Strategic Land and Resources Plan boundaries, 2016.",
		"description": "This dataset is the combination of Schedule B boundary for the Central and North Coast and the Schedule C boundary for the South Central Coast areas of the Great Bear Rainforest.",
		"source": "ohn Sunde, Jan 2016. Schedule B and Schedule C boundaries of the Great Bear Rainforest. British Columbia Ministry of Forests, Lands, and Natural Resource Operations. Accessed June 6, 2017 through",
		"sourceurl": " https://www.for.gov.bc.ca/tasb/slrp/plan17.html ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "hotspot_points",
		"datatype": "geojson",
		"theme": "canopy map marker",
		"layerlabel": "hotspot_points",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "canopy_map_marker",
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "ifl_gfwc_2016_02122020",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Intact Forest Landscapes",
		"shortdescription": "Unfragmented forest landscapes (2016).",
		"description": "Identifies the world’s last remaining unfragmented forest landscapes of at least 50,000 hectares in size, and with a minimum width of ten kilometers, large enough to retain all native biodiversity and showing no signs of human alteration as of the year 2016. The world IFL (Intact Forest Landscapes) map was created through visual interpretation of Landsat images by experts. The map may contain inaccuracies due to limitations in the spatial resolution of the imagery and lack of ancillary information about local land-use practices in some regions. In addition, the methodology assumes that fires in proximity to roads or other infrastructure may have been caused by humans, and therefore constitute a form of anthropogenic disturbance. This assumption could result in an underestimation of IFL extent in the boreal biome.",
		"source": "University of Maryland, Wildlife Conservation Society, Greenpeace, and Transparent World. \"Intact Forest Landscapes. 2016\" Accessed through Intact Forest Landscapes on January 6, 2020",
		"sourceurl": "http://www.intactforests.org/data.ifl.html",
		"fullcitation": "Potapov P., Yaroshenko A., Turubanova S., Dubinin M., Laestadius L., Thies C., Aksenov D., Egorov A., Yesipova Y., Glushkov I., Karpachevskiy M., Kostikova A., Manisha A., Tsybikova E., Zhuravleva I. 2008. Mapping the World's Intact Forest Landscapes by Remote Sensing. Ecology and Society, 13 (2)",
		"fill_color": "255,84,131",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "ind_leuser_ecosys",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Leuser Boundary",
		"shortdescription": "Leuser Ecosystem boundary.",
		"description": "The Leuser Ecosystem spans the provinces of Aceh and North Sumatra on the Island of Sumatra in Indonesia. This majestic and ancient ecosystem covers more than 2.6 million hectares of lowland rainforests, peat swamps, montane and coastal forests, and alpine meadows. Globally recognized as one of the richest expanses of tropical rainforest found anywhere in Southeast Asia, the Leuser Ecosystem is also one of Asia's largest carbon sinks. The data displayed in this map is not official data from the Indonesian Ministry of Environment and Forestry. As a result, this data may differ from official data and there may be inaccuracies.",
		"source": "Hutan Alam dan Lingkungan Aceh (HAKA). Nov. 19, 2013. Indonesia Leuser Ecosystem. Accessed through Global Forest Watch Nov. 23, 2015: ",
		"sourceurl": "http://data.globalforestwatch.org/datasets/16dae98167264b8abfbd13e23802e4f3_0",
		"fullcitation": null,
		"fill_color": "156, 156, 156",
		"fill_opacity": "0.4",
		"stroke_color": "104, 104, 104",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "ind_rhino",
		"datatype": "marker",
		"theme": "species",
		"layerlabel": "Rhino Distribution",
		"shortdescription": "Sumatran Rhino range.",
		"description": "The data layer representing habitat range of the Sumatran Rhinoceros has been removed from view and replaced with a non-site specific shape in this section of ForestMapper due to concerns that this level of site-specific visual reference could potentially be used by poachers to locate and hunt these critically endangered species. The data from these layers still exists in the combined Ancient and Endangered Forest layer of ForestMapper. The Sumatran rhinoceros, elephants, and tigers range and/or habitat are therefore included in the Ancient and Endangered Forest data layer. Read more about each species in the Information box beside their name.",
		"source": "For further information, contact Canopy directly.",
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "3.821179,97.556794",
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "mammals_richness_all_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Mammal Species Richness",
		"shortdescription": "Mammal Species Richness (2018).",
		"description": "Species richness refers to the diversity of mammal species in a measured area. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). This information does not include extinct or non-native species. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Primary mammal species range-map data used to create the diversity maps on BiodiversityMapping.org are from the IUCN. ",
		"source": "BiodiversityMapping.org, derived from digital distribution maps from the IUCN, 2018",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,212.4",
		"legend_units_label_single": "Number of Mammal Species",
		"legend_units_label": null,
		"listed_order": "7",
		"tile_opacity": null
	},
	{
		"datacode": "mammals_threatened_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Threatened Mammals",
		"shortdescription": "Threatened Mammals (2018).",
		"description": "Threatened in this case refers to mammals that are vulnerable, endangered, or critically endangered (IUCN). Threatened mammal species range-map data used to create the diversity maps on BiodiversityMapping.org are from the IUCN. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps from the IUCN, 2018",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,33.6",
		"legend_units_label_single": "Number of Mammal Species",
		"legend_units_label": null,
		"listed_order": "8",
		"tile_opacity": null
	},
	{
		"datacode": "natural_earth_water",
		"datatype": "tileLayer",
		"theme": null,
		"layerlabel": "Rivers and Lakes",
		"shortdescription": "North American Rivers and Lakes.",
		"description": "North America rivers and lakes made with Natural Earth. naturalearthdata.com. 1:1 million river and lake centerlines, version 3.0.0 accessed June 2017. ",
		"source": null,
		"sourceurl": "http://www.naturalearthdata.com",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "orangutan_2017_02132020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Orangutan Distribution",
		"shortdescription": "Sumatran Orangutan habitat range (2017).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran orangutan (pongo abelii) is considered a critically endangered species by the IUCN with populations decreasing rapidly due to high levels of habitat conversion and fragmentation, and illegal killing. Forest loss data indicate that key Sumatran Orangutan forest habitat (i.e., below 500 m asl) was reduced by 60% of its area between 1985 and 2007 (Wich et al. 2008, 2011).",
		"source": "The IUCN Red List of Threatened Species 2017, Downloaded on 13 February 2020.",
		"sourceurl": "https://www.iucnredlist.org/species/121097935/123797627",
		"fullcitation": "Singleton, I., Wich , S.A., Nowak, M., Usher, G. & Utami-Atmoko, S.S. 2017. Pongo abelii (errata version published in 2018). The IUCN Red List of Threatened Species 2017: e.T121097935A123797627. https://dx.doi.org/10.2305/IUCN.UK.2017-3.RLTS.T121097935A115575085.en. Downloaded on 13 February 2020.",
		"fill_color": "76, 0, 115",
		"fill_opacity": "0.6",
		"stroke_color": "76, 0, 115",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "soil_carbon_02132020",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Soil Organic Carbon Stock",
		"shortdescription": "Soil organic carbon stock (2017).",
		"description": "This dataset identifies soil organic carbon stock in the topsoil (0-30 cm depth). Soil organic carbon represents all the non-living organic compounds in soil. Plants use the organic carbon in soil as they grow. In turn, they return carbon to the soil after they die. High levels of organic soil carbon do not necessarily represent areas with lush vegetation, however. For example, in tropical rainforests, the highly active vegetation on the surface extracts most soil carbon, so those areas have especially low soil carbon. Areas where vegetation grows more slowly, especially swamps and wetlands, therefore have higher soil carbon. The measure is especially important because it plays a key role in the carbon cycle and overall climate stability. ",
		"source": "Hengl T, Mendes de Jesus J, Heuvelink GBM, Ruiperez Gonzalez M, Kilibarda M, Blagotic A, et al. (2017) SoilGrids250m: Global gridded soil information based on machine learning. PLoS ONE 12(2): e0169748. doi:10.1371/journal.pone.0169748. Accessed through ISRIC on 3/10//2020. ",
		"sourceurl": "https://data.isric.org/geonetwork/srv/eng/catalog.search;jsessionid=550B877481DF5AD3F7745DC7068880E6#/metadata/ea80098c-bb18-44d8-84dc-a8a1fbadc061",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "0,400",
		"legend_units_label_single": "tons / ha",
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "temperate_rainforest",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Temperate Rainforest Extent",
		"shortdescription": "Temperate and perhumid boreal forests of the world.",
		"description": "This data layer includes Temperate Rainforest extent of the Pacific Coast North America, inland Northwestern North America, Chile and Argentina, Japan and Australasia. It also includes Relict Temperate, Perhumid boreal and hemiboreal forests in Europe, Eastern Canada, and the Eastern side of the Korean Peninsula. This data layer was created by Henrik vonWehrden using the Maxent model for the book, DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp.",
		"source": "Henrik vonWehrden in DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp. Accessed March 26, 2015 through DataBasin. ",
		"sourceurl": "http://databasin.org/maps/96307c4ce4284ad99ba3dee3be506492 ",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "7",
		"tile_opacity": null
	},
	{
		"datacode": "tiger_iucn_2015_02132020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Tiger Distribution",
		"shortdescription": "Tiger Conservation Landscapes (2014).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran tiger (panthera tigris sumatrae) is a rare tiger subspecies that inhabits the Indonesian island of Sumatra. It was listed as Critically Endangered on the IUCN Red List in 2008 as the population was estimated at 441 to 679 individuals, with no subpopulation larger than 50 individuals and a declining trend. Tigers need large contiguous forest blocks to thrive. A Tiger Conservation Landscape (TCL) is a block or cluster of blocks of habitat meeting a minimum-size threshold specific to habitat type, where tigers have been confirmed in the last 10 years and are not known to have been extirpated. Classes I - IV were included.",
		"source": "The IUCN Red List of Threatened Species 2015, Downloaded on 13 February 2020.",
		"sourceurl": "https://www.iucnredlist.org/species/15955/50659951",
		"fullcitation": "Goodrich, J., Lynam, A., Miquelle, D., Wibisono, H., Kawanishi, K., Pattanavibool, A., Htun, S., Tempa, T., Karki, J., Jhala, Y. & Karanth, U. 2015. Panthera tigris . The IUCN Red List of Threatened Species 2015: e.T15955A50659951. https://dx.doi.org/10.2305/IUCN.UK.2015-2.RLTS.T15955A50659951.en. Downloaded on 13 February 2020.",
		"fill_color": "242, 92,17",
		"fill_opacity": "0.6",
		"stroke_color": "168, 56, 0",
		"stroke_weight": "0.1",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "treecov_12112019",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Tree Cover",
		"shortdescription": "Identifies areas of tree cover for the year 2010.",
		"description": "Identifies areas of tree cover for the year 2010. At 30x30 m resolution tree cover was defined as all vegetation taller than five meters in height. Tree cover is the biophysical presence of trees and may take the form of natural forests or plantations existing over a range of canopy densities. Tip: Click on both the Tree Cover and Tree Loss layers to have a better view of the changes that occurred within that period.",
		"source": "Hansen/UMD/Google/USGS/NASA, accessed through: Global Land Analysis & Discovery on November 21, 2019",
		"sourceurl": "https://glad.umd.edu/dataset/global-2010-tree-cover-30-m",
		"fullcitation": "Hansen, M.C., Potapov, P.V., Moore, R., Hancher, M., Turubanova, S.A., Tyukavina, A., Thau, D., Stehman, S.V., Goetz, S.J., Loveland, T.R., Kommareddy, A., Egorov, A., Chini, L., Justice, C.O., and Townshend, J.R.G., 2013, High-Resolution Global Maps of 21st-Century Forest Cover Change: Science, v. 342, no. 6160, p. 850-853, at\nhttp://www.sciencemag.org/content/342/6160/850.abstract.",
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "0, 100",
		"legend_units_label_single": null,
		"legend_units_label": "%",
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "treeloss_12112019",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Tree Loss (2000 - 2018)",
		"shortdescription": "Areas of tree cover loss (2000 - 2018).",
		"description": "\"Tree cover\" is defined as all vegetation greater than five meters in height, and may take the form of natural forests or plantations across a range of canopy densities. \"Loss\" indicates the removal or mortality of tree cover and can be due to a variety of factors, including mechanical harvesting, fire, disease, or storm damage. As such, \"loss\" does not always equate to deforestation. Tip: Click on both the Tree Cover and Tree Loss layers to have a better view of the changes that occurred within that period.",
		"source": "2000 - 2018, Hansen/UMD/Google/USGS/NASA, Accessed through Google Earth Engine Partners on November 15, 2019",
		"sourceurl": "https://earthenginepartners.appspot.com/science-2013-global-forest/download_v1.6.html",
		"fullcitation": "Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from: http://earthenginepartners.appspot.com/science-2013-global-forest.",
		"fill_color": "239, 59, 44",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "vancouver_island",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Vancouver Island Boundary",
		"shortdescription": "Vancouver Island, British Columbia, Canada.",
		"description": "Vancouver Island has some of the richest temperate rainforests on Earth, but has lost up to 90% of the largest old-growth rainforests to logging and development. These remaining pockets of old-growth forest contain important species habitat, and play a critical role in stabilizing the Earth's climate through carbon storage. This Vancouver Island boundary is derived from ESRI Global country boundaries with a 5km buffer.",
		"source": "Accessed through ArcGIS Online, October 18, 2017. ",
		"sourceurl": "https://www.arcgis.com/home/item.html?id=2ca75003ef9d477fb22db19832c9554f ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "vancouver_island_marker",
		"datatype": "marker",
		"theme": "earth engine map marker",
		"layerlabel": "vancouver_island_marker",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "48.72306,-124.12302",
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "wwf_deforestation_fronts_02122020",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Global Deforestation Fronts",
		"shortdescription": "Likely deforestation locations from 2010 to 2030.",
		"description": "Most of the deforestation from 2010 until 2030 will likely happen in 11 deforestation fronts, places that will account for over 80 per cent of the forest loss projected globally by 2030. These fronts, ten of which are in the tropics, are where efforts to halt deforestation must be concentrated.",
		"source": "WWF Global Observation and Biodiversity Information Portal (GLOBIL), Created: March 30, 2015, Updated: February 5, 2020, Accessed on January 6, 2020.",
		"sourceurl": "https://panda.maps.arcgis.com/home/item.html?id=e7415ab9256949e4994f711a99cac758",
		"fullcitation": null,
		"fill_color": "198, 41, 66",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "8",
		"tile_opacity": null
	}
];


//////////////////
// WEBPACK FOOTER
// ./data/data_inventory.json
// module id = 547
// module chunks = 1